export default {
	getCompanies(cb) {
		let companies = firebase.database().ref('companies').orderByChild('timestamp');
		companies.on('value', function (snapshot) {
			let company = snapshot.val();
			if (company === null || company === undefined) return;
			cb(company);
		});
	},
	createCompany(company, cb) {
		let key = firebase.database().ref('companies').push().key;
		let newCompany = firebase.database().ref('companies/' + key);
		newCompany.set({
			id: key,
			"InternalName": company['InternalName'] || '',
			"LogoName": company['LogoName'] || (company['InternalName'] ? company['InternalName'].toLowerCase() + '.svg' : ''),
			"LogoPosition": company['LogoPosition'] || 'left',
			"Name": company['Name'] || '',
			"Address": {
				"Street": company['Address'] && company['Address']['Street'] || '',
				"House": company['Address'] && company['Address']['House'] || '',
				"PLZ": company['Address'] && company['Address']['PLZ'] || '',
				"City": company['Address'] && company['Address']['City'] || '',
			},
			"Phone": company['Phone'] || '',
			"Fax": company['Fax'] || '',
			"Email": company['Email'] || '',
			"Site": company['Site'] || '',
			"Logo": company['Logo'] || '',
			"Owners": company['Owners'] || '',
			"Registration": company['Registration'] || '',
			"TaxNumber": company['TaxNumber'] || '',
			"Type": company['Type'] || '',
			"isMain": company['isMain'] || false,
			"BankDetails": {
				"BankName": company['BankDetails'] && company['BankDetails']['BankName'] || '',
				"IBAN": company['BankDetails'] && company['BankDetails']['IBAN'] || '',
				"BIC": company['BankDetails'] && company['BankDetails']['BIC'] || '',
			},
			"timestamp": Date.now(),
		});
		newCompany.once('value', function (snapshot) {
			let saved = snapshot.val();
			if (saved === null || saved === undefined) return;
			cb(saved);
		});
	},
	updateCompany(company, cb) {
		let ref = firebase.database().ref('companies').child(company.id);
		ref.update({
			id: company.id,
			"InternalName": company['InternalName'] || '',
			"LogoName": company['LogoName'] || '',
			"LogoPosition": company['LogoPosition'] || 'left',
			"Name": company['Name'] || '',
			"Address": {
				"Street": company['Address'] && company['Address']['Street'] || '',
				"House": company['Address'] && company['Address']['House'] || '',
				"PLZ": company['Address'] && company['Address']['PLZ'] || '',
				"City": company['Address'] && company['Address']['City'] || '',
			},
			"Phone": company['Phone'] || '',
			"Fax": company['Fax'] || '',
			"Email": company['Email'] || '',
			"Site": company['Site'] || '',
			"Logo": company['Logo'] || '',
			"Owners": company['Owners'] || '',
			"Registration": company['Registration'] || '',
			"TaxNumber": company['TaxNumber'] || '',
			"Type": company['Type'] || '',
			"isMain": company['isMain'] || false,
			"BankDetails": {
				"BankName": company['BankDetails'] && company['BankDetails']['BankName'] || '',
				"IBAN": company['BankDetails'] && company['BankDetails']['IBAN'] || '',
				"BIC": company['BankDetails'] && company['BankDetails']['BIC'] || '',
			},
		});
		if (cb) cb(company);
	},
	removeCompany(id, cb) {
		firebase.database().ref('companies/' + id).remove();
		if (cb) cb(id);
	},
}



// WEBPACK FOOTER //
// ./src/api/companies.js